import type { ReactNode } from 'react'

export function FeedVideoGrid({ children }: { children: ReactNode }) {
  return <div className="feed-video-grid grid grid-cols-2 gap-x-2.5 gap-y-4 desk:grid-cols-4 desk:gap-x-3.5 desk:gap-y-5 desk:xl:grid-cols-5 desk:2xl:grid-cols-6">{children}</div>
}

export function FeedTextGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 desk:gap-3 desk:xl:grid-cols-3">{children}</div>
}
